module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content-form"
  }, [(_vm.content !== false && !_vm.selecting) ? _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "content-item"
  }, [_c('strong', [_c('em', [_vm._v(_vm._s(_vm.content.page_content_type))])]), _vm._v("\n      -\n      "), (_vm.linked.name) ? _c('router-link', {
    attrs: {
      "to": {
        name: _vm.content.page_content_type.toLowerCase(),
        params: {
          id: _vm.content.page_content_id
        }
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.linked.sku ? '#' + _vm.linked.sku + ' - ' : '') + " " + _vm._s(_vm.linked.name) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.linked.images && _vm.linked.images.length > 0) ? _c('div', {
    staticClass: "columns margin-top"
  }, [_c('div', {
    staticClass: "column is-3"
  }, [_c('img', {
    attrs: {
      "src": _vm.linked.images[0].thumbnail_path
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column is-9"
  }, [_vm._v("\n          " + _vm._s(_vm.linked.description) + "\n          "), _c('br'), _vm._v(" "), (_vm.linked.price) ? _c('span', [_c('strong', [_vm._v(_vm._s(_vm._f("currency")(_vm.linked.price)))])]) : _vm._e()])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "content-controls"
  }, [_c('div', {
    staticClass: "level is-mobile"
  }, [_c('div', {
    staticClass: "level-right"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('a', {
    staticClass: "button is-small",
    attrs: {
      "title": "change content"
    },
    on: {
      "click": function($event) {
        return _vm.edit()
      }
    }
  }, [_vm._v("Edit")])]), _vm._v(" "), _c('div', {
    staticClass: "level-item"
  }, [_c('a', {
    staticClass: "button is-small",
    attrs: {
      "title": "move to top"
    },
    on: {
      "click": function($event) {
        return _vm.moveToTop()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "level-item"
  }, [_c('a', {
    staticClass: "button is-small",
    attrs: {
      "title": "move up"
    },
    on: {
      "click": function($event) {
        return _vm.moveUp()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-up"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "level-item"
  }, [_c('a', {
    staticClass: "button is-small",
    attrs: {
      "title": "move down"
    },
    on: {
      "click": function($event) {
        return _vm.moveDown()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-down"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "level-item"
  }, [_c('a', {
    staticClass: "button is-small",
    attrs: {
      "title": "move to bottom"
    },
    on: {
      "click": function($event) {
        return _vm.moveToBottom()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "level-item"
  }, [_c('a', {
    staticClass: "delete",
    attrs: {
      "title": "remove content from page"
    },
    on: {
      "click": function($event) {
        return _vm.remove()
      }
    }
  })])])])]), _vm._v(" "), (_vm.content.content) ? _c('div', {
    staticClass: "content-display ql-content",
    domProps: {
      "innerHTML": _vm._s(_vm.content.content)
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.selecting) ? _c('div', {
    staticClass: "content-select"
  }, [_c('div', {
    staticClass: "level"
  }, [_c('div', {
    staticClass: "level-left"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedType),
      expression: "selectedType"
    }],
    attrs: {
      "name": "contentType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "product"
    }
  }, [_vm._v("Product")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "bundle"
    }
  }, [_vm._v("Bundle")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "text"
    }
  }, [_vm._v("Text")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "level-item"
  }, [(_vm.selectedType === 'product') ? _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedItem),
      expression: "selectedItem"
    }],
    attrs: {
      "name": "selectedItem"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedItem = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', [_vm._v("Select a product...")]), _vm._v(" "), _vm._l((_vm.products), function(product) {
    return _c('option', {
      domProps: {
        "value": product.id
      }
    }, [_vm._v("\n                                      " + _vm._s(product.sku) + " - " + _vm._s(product.short_name) + "\n                                  ")])
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.selectedType === 'bundle') ? _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedItem),
      expression: "selectedItem"
    }],
    attrs: {
      "name": "selectedItem"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedItem = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', [_vm._v("Select a bundle...")]), _vm._v(" "), _vm._l((_vm.bundles), function(bundle) {
    return _c('option', {
      domProps: {
        "value": bundle.id
      }
    }, [_vm._v("\n                                      " + _vm._s(bundle.name))])
  })], 2)])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "level-item"
  }, [_c('div', [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveContent()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.cancel()
      }
    }
  }, [_vm._v("Cancel")])])])])]), _vm._v(" "), (_vm.selectedType === 'text') ? _c('p', {
    staticClass: "control ql-content"
  }, [_c('quill-editor', {
    ref: "myTextEditor",
    model: {
      value: (_vm.text),
      callback: function($$v) {
        _vm.text = $$v
      },
      expression: "text"
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.content === false && !_vm.selecting) ? _c('div', {
    staticClass: "add-content"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.addContent()
      }
    }
  }, [_vm._m(0), _vm._v("\n      Add content to page\n    ")])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-265818d3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/components/PageContent.vue
// module id = 512
// module chunks = 0